package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.HeadlineTextStyle
import club.srams.website.SubheadlineTextStyle
import club.srams.website.components.layouts.PageLayoutData
import club.srams.website.components.sections.CarouselSection
import club.srams.website.components.sections.VideoSection
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div

@InitRoute
fun initFieldTripsPage_v2(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Field Trips v2"))
}

@Page("/field-trips-v2")
@Layout(".components.layouts.PageLayout")
@Composable
fun FieldTripsPage_v2() {
    // — Title —
    Row(HeroContainerStyle.toModifier()) {
        Box {
            Column(Modifier.gap(2.cssRem)) {
                Div(HeadlineTextStyle.toAttrs()) {
                    SpanText(
                        "Field Trips"
                        , Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }
    }

    // — Introduction —
    Row {
        Column {
            FieldTripIntroductionPage()
        }
    }

    // — Schedule —
    Row {
        Column {
            FieldTripSchedulePage()
        }
    }

    HorizontalDivider(Modifier.fillMaxWidth())

    Div(HeadlineTextStyle.toAttrs()) {
        SpanText(
            "Past Trips", Modifier.color(
                when (ColorMode.current) {
                    ColorMode.LIGHT -> Colors.Black
                    ColorMode.DARK -> Colors.White
                }
            )
        )
    }

    // — Brown Creek Campground —
    VideoSection(
        title = "2026.05.22 Brown Creek Campground",
        videoUrl = "/images/field_trips/2026/05_22_Brown_Creek_Campground/video_1.mp4"
    )

    // — Stan Hedwall Park —
    CarouselSection(
        title = "2026.03.28 Stan Hedwall Park",
        images = `2026_03_28_stan_hedwall_park`
    )

    // — North Beach County Park —
    CarouselSection(
        title = "2025.11.08 North Beach County Park",
        images = `2025_11_08_north_beach_county_park`
    )

    // — Dosewallips State Park —
    CarouselSection(
        title = "2025.10.14 Dosewallips State Park",
        images = `2025_10_14_dosewallips_state_park`
    )
}


private val `2025_10_14_dosewallips_state_park` = listOf(
    Pair("/images/field_trips/2025/10_14_dosewallips_state_park/image_1.jpg", "Dosewallips State Park"),
//    Pair("/images/field_trips/2025/10_14_dosewallips_state_park/image_2.jpg", "Dosewallips State Park"),
//    Pair("/images/field_trips/2025/10_14_dosewallips_state_park/image_3.jpg", "Dosewallips State Park"),
//    Pair("/images/field_trips/2025/10_14_dosewallips_state_park/image_4.jpg", "Dosewallips State Park"),
//    Pair("/images/field_trips/2025/10_14_dosewallips_state_park/image_5.jpg", "Dosewallips State Park"),
)

private val `2025_11_08_north_beach_county_park` = listOf(
    Pair("/images/field_trips/Field_Guide_to_Rocks_Port_Townsend.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_1.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_2.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_3.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_4.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_5.jpg", "North Beach County Park"),
    Pair("/images/field_trips/2025/11_08_north_beach_county_park/image_6.jpg", "North Beach County Park"),
)

private val `2026_03_28_stan_hedwall_park` = listOf(
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_1.jpg", "Stan Hedwall Park"),
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_2.jpg", "Stan Hedwall Park"),
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_3.jpg", "Stan Hedwall Park"),
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_4.jpg", "Stan Hedwall Park"),
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_5.jpg", "Stan Hedwall Park"),
    Pair("/images/field_trips/2026/03_28_Stan_Hedwall/image_6.jpg", "Stan Hedwall Park"),
)

private val `2026_05_22_brown_creek_tail` = listOf(
    Pair("/images/field_trips/2026/05_22_Brown_Creek_Campground/video_1.jpg", "Brown Creek Campground"),
)